<dk-navbar></dk-navbar>
<dk-header></dk-header>
<router-outlet></router-outlet>
<dk-contact></dk-contact>
<dk-cookie-banner
  [@fadeInOut]
  *ngIf="!cookiesAccepted"
  (accepted)="toggleCookiesAccepted()"
></dk-cookie-banner>
